// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1P0yi","item":"PaymentsMobile_item__15yGt","label":"PaymentsMobile_label__icUq5","amount":"PaymentsMobile_amount__1RPSw"};